// TODO: langCode handling on creation
// TODO: remove langCode in news props form
// TODO: handle translation connections

module.exports = {
	extends: [
		'/',
		'base',
		'form',
		'form'
	],

	methods: {

		onChange: function(isRelationChange, changeDone, fieldData){
			let updateTabTitle;
			const fieldCode = (fieldData || {}).fieldCode;

			if(fieldCode === 'title') {
				updateTabTitle = (fieldData || {}).fieldValue;
			}

			if(updateTabTitle){
				const data = (this.resourceData || {}).data || {}
				const attributes = data.attributes || {}
				const entityID = attributes[data.primaryKey || 'id'] || ''

				let entityPrefix = '';
				if(entityID && this.hasRoleOption('showIDs')){
					entityPrefix = '#' + entityID + ' - ';
				}

				this.furthest('base_tabStrip_tabContent', undefined, function(tabContent){
					var registerSecret = (tabContent.config || {}).registerSecret;
					if(registerSecret !== undefined){
						tabContent.closest('base_tabStrip_tabStrip', function(tabStrip){
							tabStrip.refreshTab(registerSecret, {
								title: entityPrefix + updateTabTitle
							});
						});
					}
				});
			}
		},

		onAttachDone: function(){
			const $field = this.$.find('.field.fieldOf_langCode')
			if($field.length > 0){
				if(this.hasAccessTo('usage:languages:showRouteLanguageDetails')){
					const data = this.resourceData.data || {}
					const primaryKey = (data.attributes || {})[data.primaryKey || 'id']
					if(primaryKey){
						const routeDetails = ((this.resourceData.routeDetails || {}).data || {}).attributes || {}
						const langCode = this.getFieldValue('langCode', 'live') || 'NO_LANG'
						const inheritedLangCode = routeDetails.inheritedLangCode || 'NO_LANG'
						$field.append(`<label class="inline">langCode: ${langCode}, inheritedLangCode: <b>${inheritedLangCode}</b></label>`)

						if(this.config.useCase != 'rootNode'){
							$field.find('.toggleOption').addClass('disabled')
						}
					}
				} else if(this.config.useCase != 'rootNode'){
					$field.find('[data-field-code="langCode"]').attr('DISABLED', 'DISABLED')
					$field.hide();
				}
			}
		},
	},

	handlers: [
		{
			name: 'onDeleteNews',
			componentClass: 'templates_news_table_table',
			handle: function(callerComponent, primaryKey){
				var data = this.resourceData.data || {};
				var attributes = data.attributes || {};
				if(primaryKey && attributes[data.primaryKey || 'id'] === primaryKey){
					this.furthest('base_tabStrip_tabContent', undefined, function(tabContent){
						tabContent.close(true);
					});
				}
			}
		},
	]
};
